import {Assignment, ContentCopy, List} from "@mui/icons-material";
import React, {useEffect, useState, useContext} from "react";
import {BrandContext} from "@context/BrandContext";
import Tab from "@common/Tab";
import Tabs from "@common/Tabs";
import TeacherTrails from './TeacherTrails';
import CircularLoader from "@common/CircularLoader";
import TeacherTrailAssignments from "./TeacherTrailAssignments";

const TeacherTrailTabs = (props) => {
    const brandConfig = useContext(BrandContext);
    const [loading, setLoading] = useState(true);
    const [tabs, setTabs] = useState([]);

    useEffect(()=>{
        $.getScripts(['/users/trail/js/trailBuilder.js']).done(function() {
            setLoading(false);
        });
    },[]);

    useEffect(()=>{
        const tasksNameLowerCase = brandConfig.tasksName.toLowerCase();

        if(brandConfig.hideSharedPathways) {
            setTabs([
                {id:'my-tasks', name: 'My ' + brandConfig.tasksName, val: 0, hash: 'my-'+tasksNameLowerCase, component:<TeacherTrails pathwayType="TASK"/>, icon:<List/>},
                {id:'my-templates', name: 'My Templates', val: 1, hash: 'my-templates', component:<TeacherTrails pathwayType="PATHWAY"/>, icon:<ContentCopy/>},
                {id:'assigned-tasks', name:'Assigned Tasks', val: 3, hash: 'assigned-tasks', component:<TeacherTrailAssignments/>, icon:<Assignment/>}
            ]);
        } else {
            setTabs([
                {id:'my-tasks', name: 'My ' + brandConfig.tasksName, val: 0, hash: 'my-'+tasksNameLowerCase, component:<TeacherTrails pathwayType="TASK"/>, icon:<List/>},
                {id:'my-templates', name: 'My Templates', val: 1, hash: 'my-templates', component:<TeacherTrails pathwayType="PATHWAY"/>, icon:<ContentCopy/>},
                {id:'shared-tasks', name:'Shared ' + brandConfig.tasksName, val: 2, hash: 'shared-'+tasksNameLowerCase, component:<TeacherTrails pathwayType="TASK" sharedPathways={true}/>, icon:<List/>},
                {id:'shared-templates', name:'Shared Templates', val: 3, hash: 'shared-templates', component:<TeacherTrails pathwayType="PATHWAY" sharedPathways={true}/>, icon:<ContentCopy/>},
                {id:'school-tasks', name:'School ' + brandConfig.tasksName, val: 4, hash: 'school-'+tasksNameLowerCase, component:<TeacherTrails pathwayType="TASK" schoolPathways={true}/>, icon:<List/>},
                {id:'assigned-tasks', name:'Assigned ' + brandConfig.tasksName, val: 5, hash: 'assigned-tasks', component:<TeacherTrailAssignments/>, icon:<Assignment/>}
            ]);
        }
    },[brandConfig]);

    return (
        <>
            <div id="teacherTrailTabsWrapper">
                {loading && <CircularLoader/>}
                {!loading && <Tabs id={'teacherTrailTabs'} variant="standard" destroyOnHidden={true}>
                    {tabs.map((tab)=>{
                        return (
                            <Tab
                                key={tab.val} value={tab.val}
                                id={tab.id}
                                className={'trailer-tab-content'}
                                hash={tab.hash}
                                children={
                                    <div>
                                        {!brandConfig.useReactEditTrail ? (
                                            <>
                                                <div id={'selectedTrailComponent'}>{tab.component}</div>
                                                <div id="pathwayBuilder"></div>
                                            </>
                                        ) : (
                                            <>{tab.component}</>
                                        )}
                                    </div>
                                }
                                tab={
                                    <>
                                        {tab.icon}
                                        <span className={'margin-r--m margin-l--s tabText'}>{tab.name}</span>
                                    </>
                                }
                             />
                        );
                    })}
                </Tabs>}
            </div>
        </>
    )
}

function openDuplicateMedia(mediaId, mediaType) {
    $( "#gen-dialog" ).html('<p>Are you sure you want to duplicate this media item?</p><p><input type="checkbox" className="js-replaceMediaInContent">Replace media item in content</p>')
    $( "#gen-dialog" ).dialog({
        resizable: false,
        height: "auto",
        width: 500,
        modal: false,
        title: 'Duplicate media',
        buttons: {
            "Duplicate": function() {
                var replaceMediaInContent = $('.js-replaceMediaInContent', $(this)).is(":checked");
                duplicateMedia(mediaId, mediaType, replaceMediaInContent, true);
                $( this ).dialog( "close" );
            },
            Cancel: function() {
                $( this ).dialog( "close" );
            }
        }
    });
}

export default TeacherTrailTabs;
